import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import deTranslations from './locales/de.json';

// Define supported UI languages
export const SUPPORTED_UI_LANGUAGES = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
} as const;

export type UILanguage = keyof typeof SUPPORTED_UI_LANGUAGES;

// Configure i18next
i18n
  // Detect user language from browser/localStorage
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      de: { translation: deTranslations },
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Language detection configuration
    detection: {
      // Order and from where user language should be detected
      order: ['localStorage', 'navigator', 'htmlTag'],

      // Keys or params to lookup language from
      lookupLocalStorage: 'uiLanguage',

      // Cache user language
      caches: ['localStorage'],

      // Optional htmlTag with lang attribute to check
      htmlTag: document.documentElement,
    },

    interpolation: {
      escapeValue: false, // React already safes from xss
    },

    react: {
      useSuspense: false, // Set to false to avoid suspense-related issues
    },
  });

export default i18n;
